import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToSection(_ctx.sectionId))),
    class: "flex items-center justify-center text-2xl hover:scale-110 transition-transform duration-300 ease-in-out border-r border-white pr-4"
  }, [
    _createVNode(_component_font_awesome_icon, {
      icon: ['fas', _ctx.icon]
    }, null, 8, ["icon"])
  ]))
}